import { get, post, remove, put } from "../api_helper";
import * as url from "../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const getJobCategoryDetails = (id) =>
  get(`${baseURL}${url.JOBCATEGORY_BASE}/${id}`);

export const getJobCategories = ({ page, pageSize }) =>
  get(`${baseURL}${url.JOBCATEGORY_BASE}?pageNumber=${page}&pageSize=${pageSize}`);

export const updateJobCategory = (ID, payload) =>
  put(`${baseURL}${url.JOBCATEGORY_BASE}/${ID}`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

export const createJobCategory = (payload) =>
  post(`${baseURL}${url.JOBCATEGORY_BASE}`, payload);

// export const deleteJobCategory = (ID) =>
//   remove(`${baseURL}${url.JOBCATEGORY_BASE}/${ID}`);
export const deleteJobCategory = (ID) =>
  remove(`${baseURL}${url.JOBCATEGORY_BASE}?id=${ID}`);

export const getLookupJobCategories = () =>
  get(`${baseURL}${url.JOBCATEGORY_BASE}/lookup`);

export const getExitSurveyLookupJobCategories = () =>
  get(`${baseURL}/EmployeeExitSurvey/GetJobCategories`);
